import React from "react";
import { IMyTradeTransaction } from "./IMyTradeTransaction";
import { MAIN_CURRENCY_LABEL } from "@bundles/consts";
import { MobileExpandedRow } from "@apps/MarketsApp/components/MobileExpandedRow";
import { formatNumberWithCommas } from "@features/utils/functions";
import moment from "moment";
import Big from "big.js";
import ETradeTypes from "@market/enums/TradeTypes";
import PDFIcon from "@assets/images/pdf-icon.svg";

type Props = {
  trade: IMyTradeTransaction;
  onAgreementClick: (id: number) => void;
};

const typeLabels = {
  [ETradeTypes.buy]: "Buy",
  [ETradeTypes.sell]: "Sell",
};

const big = Big();

const calculateTotalAmount = (trade: IMyTradeTransaction) => {
  if (trade.type === ETradeTypes.buy) {
    return big(Number(trade.price_per_share ?? 0))
      .times(Number(trade.number_of_shares ?? 0))
      .plus(Number(trade.fee_amount ?? 0));
  }

  return big(Number(trade.price_per_share ?? 0))
    .times(Number(trade.number_of_shares ?? 0))
    .minus(Number(trade.fee_amount ?? 0));
};

export const MyTradeMobileExpandedRow = ({
  trade,
  onAgreementClick,
}: Props) => {
  const rows = [
    {
      label: "DATE",
      content: moment(trade.created_at).format("DD MMM, YYYY h:mm A"),
    },
    { label: "TYPE", content: typeLabels[trade.type] },
    { label: "STATUS", content: trade.status },
    {
      label: "SHARE PRICE",
      content: `${formatNumberWithCommas(
        Number(trade.price_per_share ?? 0)
      )} ${MAIN_CURRENCY_LABEL}`,
    },
    {
      label: "SHARE AMOUNT",
      content: formatNumberWithCommas(Number(trade.number_of_shares ?? 0), 0),
    },
    {
      label: "FEE",
      content: `${formatNumberWithCommas(
        Number(trade.fee_amount ?? 0),
        4
      )} ${trade.fee_currency.toUpperCase()}`,
    },
    {
      label: "TOTAL AMOUNT",
      content: (
        <>
          <div>{formatNumberWithCommas(calculateTotalAmount(trade), 4)}</div>
          <div className="text-xs text-gray-500">
            {`${
              trade.type === ETradeTypes.buy ? "+" : "-"
            } ${formatNumberWithCommas(
              Number(trade.fee_amount ?? 0),
              4
            )} ${trade.fee_currency.toUpperCase()}`}
          </div>
        </>
      ),
    },
    {
      label: "AGREEMENT",
      content: (
        <div
          className="cursor-pointer"
          onClick={() => onAgreementClick(trade.id)}
        >
          <PDFIcon />
        </div>
      ),
    },
  ];

  return <MobileExpandedRow rows={rows} />;
};
